import type { ModuleDefinition } from '../types';

export const documentsModule: ModuleDefinition = {
  key: 'documents',
  milestone: 'M7',
  network: { path: 'documents', permission: 'document.read', labelKey: 'documents' },
  tenant: { path: 'documents', permission: 'document.read', labelKey: 'documents' },
  load: () => import('./DocumentsModule'),
};
